import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import UserAgentMixin from '../helpers/mixins/UserAgentMixin';
import SalesPageMixin from '../helpers/mixins/SalesPageMixin';
let FreePlans = class FreePlans extends Mixins(UserAgentMixin, SalesPageMixin) {
    constructor() {
        super(...arguments);
        this.toggleFreeDialog = false;
    }
    get freeFeatures() {
        return [
            {
                title: 'No credit card requirement',
                description: `Create your online store for free without providing any credit 
                      card information. We only bill you when there’s conversion.`,
            },
            {
                title: 'Cancel anytime',
                description: `If you feel that our Mini App is not the sales channel that 
                      you are looking for, you can cancel your plan or deactivate the Mini App 
                      anytime.`,
            },
            {
                title: 'No upfront and monthly subscription fees',
                description: `We only charge 10 pesos to your customers for every successful
                      transaction, labeled as “Convenience Fee”. Convenience fee can be shouldered 
                      by Merchant upon sending request to us.`,
            },
            {
                title: 'Upload up to 100 Products',
                description: `Under Free-tier subscription, you can upload up to 100 Products
                      on your store. Once you reached 10,000 monthly order volume, you can reach 
                      out to us to increase this.`,
            },
            {
                title: 'Order Volume Based Upgrade',
                description: `Your plan type automatically starts at Starter plan with lower
                      monthly transactions once you sign up. Depending on your number of 
                      monthly orders, you can unlock and upgrade your plan for free to enjoy 
                      more services and benefits from us. Plan upgrade means more VIP treatment.`,
            },
        ];
    }
};
FreePlans = __decorate([
    Component({
        components: {
            FreePlansDialog: () => import('./FreePlansDialog.vue'),
        },
    })
], FreePlans);
export default FreePlans;
